import { render, staticRenderFns } from "./ClassRoomTeacherEdit.vue?vue&type=template&id=6ff10ca6&scoped=true&"
import script from "./ClassRoomTeacherEdit.vue?vue&type=script&lang=js&"
export * from "./ClassRoomTeacherEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff10ca6",
  null
  
)

export default component.exports